import { render, staticRenderFns } from "./LocalParticipant.vue?vue&type=template&id=6329b7d6&scoped=true"
import script from "./LocalParticipant.vue?vue&type=script&lang=js"
export * from "./LocalParticipant.vue?vue&type=script&lang=js"
import style0 from "./LocalParticipant.vue?vue&type=style&index=0&id=6329b7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329b7d6",
  null
  
)

export default component.exports